import "./component.scss";
